"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Menu = _interopRequireDefault(require("@material-ui/core/Menu"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));

var _Card = _interopRequireDefault(require("./Card.css"));

var ActionMenu =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(ActionMenu, _React$PureComponent);

  function ActionMenu() {
    (0, _classCallCheck2.default)(this, ActionMenu);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ActionMenu).apply(this, arguments));
  }

  (0, _createClass2.default)(ActionMenu, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          anchor = _this$props.anchor,
          onClose = _this$props.onClose,
          options = _this$props.options;
      return _react.default.createElement(_Menu.default, {
        id: "header-menu",
        anchorEl: anchor,
        keepMounted: true,
        open: Boolean(anchor),
        onClose: onClose,
        classes: {
          paper: classes.actionMenu
        }
      }, options.map(function (option, index) {
        return _react.default.createElement(_MenuItem.default, {
          key: index,
          className: classes.menuItem,
          onClick: function onClick(event) {
            onClose();
            option.onClick();
          }
        }, option.icon && _react.default.createElement(_ListItemIcon.default, null, option.icon), _react.default.createElement(_Typography.default, {
          variant: "inherit",
          noWrap: true
        }, option.label));
      }));
    }
  }]);
  return ActionMenu;
}(_react.default.PureComponent);

ActionMenu.propTypes = {
  anchor: _propTypes.default.object,
  onClose: _propTypes.default.func.isRequired,
  options: _propTypes.default.array.isRequired
};
ActionMenu.defaultProps = {
  anchor: null
};

var _default = (0, _styles.withStyles)(_Card.default)(ActionMenu);

exports.default = _default;